/** MetricBox 分行 group key（KPI Trends / All Metrics 共用） */
export const STEAM_CHARTS_METRIC_BOX_GROUP = 'steamcharts';
export const ALINEA_STEAM_METRIC_BOX_GROUP = 'alinea_steam';
export const ALINEA_PS_METRIC_BOX_GROUP = 'alinea_ps';
export const ALINEA_XBOX_METRIC_BOX_GROUP = 'alinea_xbox';

/** KPI Trends MetricsSelection 配置 spread 用 */
export const alineaSteamMetricBoxBase = {
  metricBoxGroup: ALINEA_STEAM_METRIC_BOX_GROUP,
};

export const alineaPsMetricBoxBase = {
  metricBoxGroup: ALINEA_PS_METRIC_BOX_GROUP,
  hideMetricBoxIcon: true,
};

export const alineaXboxMetricBoxBase = {
  metricBoxGroup: ALINEA_XBOX_METRIC_BOX_GROUP,
  hideMetricBoxIcon: true,
};

export type TMetricBoxMeta = {
  metricBoxGroup?: string;
  hideMetricBoxIcon?: boolean;
  icon?: string;
};

/** Steam 源：PCU / ACU / Followers 同一行（All Metrics 中 followers 的 dataSource 为 vginsights） */
export const resolveSteamChartsMetricBoxMeta = (
  metricValue = '',
): TMetricBoxMeta => {
  if (
    metricValue.startsWith('source_steam__') ||
    metricValue === 'steamfollowers'
  ) {
    return { metricBoxGroup: STEAM_CHARTS_METRIC_BOX_GROUP, icon: 'source_steam' };
  }
  return {};
};

/** Alinea：Steam / PS / Xbox 分行 */
export const resolveAlineaMetricBoxMeta = (
  metricValue = '',
  icon?: string,
): TMetricBoxMeta => {
  if (metricValue.startsWith('alinea__ps_')) {
    return alineaPsMetricBoxBase;
  }
  if (metricValue.startsWith('alinea__xbox_')) {
    return alineaXboxMetricBoxBase;
  }
  if (metricValue.startsWith('alinea__')) {
    return { ...alineaSteamMetricBoxBase, icon: icon || 'alinea' };
  }
  return {};
};

/** All Metrics 指标选项补全 MetricBox 分组元数据 */
export const resolveAllMetricsMetricBoxMeta = (item: {
  value?: string;
  icon?: string;
  dataSource?: string;
  dataSourceType?: string;
}): TMetricBoxMeta => {
  const metricValue = item?.value || '';
  const steamMeta = resolveSteamChartsMetricBoxMeta(metricValue);
  if (steamMeta.metricBoxGroup) {
    return steamMeta;
  }
  const dataSourceKey = item?.dataSource || item?.dataSourceType;
  if (dataSourceKey === 'alinea') {
    return resolveAlineaMetricBoxMeta(metricValue, item?.icon);
  }
  return {};
};
